import React from 'react';
import _get from 'lodash/get';
import moment from 'moment';
import { setLocale as setYupLocale } from 'yup';
import  secureLocalStorage  from  "react-secure-storage";

let currentLanguageCode = '';

const languages: {
    [key: string]: {
        id: string;
        label: string;
        flag: string;
        dateFns: any;
        dictionary: any;
    };
} = {
    en: {
        id: 'en',
        label: 'English',
        flag: '/images/flags/United-States.png',
        dateFns: null,
        dictionary: null,
    },
    th: {
        id: 'th',
        label: 'Thai',
        flag: '/images/flags/Thai.png',
        dateFns: null,
        dictionary: null,
    },
};

export async function init() {
    // currentLanguageCode = secureLocalStorage.getItem('languageUvoice')+"" || defalutLanguage;
    // setLanguageCode(currentLanguageCode);
    let valueLang = "th";

    let urlParams = new URLSearchParams(window.location.search)
    const language = urlParams.get("lang");
    if(language != null && language != "")
    {
        valueLang = language.toLocaleLowerCase() == "en" ? "en" : "th";
    }
    else if(secureLocalStorage.getItem("languageUvoice"))
    {
      valueLang = secureLocalStorage.getItem("languageUvoice")+"";
    }
    currentLanguageCode = valueLang;
    document.cookie = "languageUvoice=" + valueLang;
    setLanguageCode(currentLanguageCode);

    if (currentLanguageCode === 'en') {
        await initEn();
    } else if (currentLanguageCode === 'th') {
        await initTh();
    }
}


async function initEn() {
    const language = languages['en'];

    language.dictionary = (
        await import('./en')
    ).default;

    if (language.dictionary.validation) {
        setYupLocale(language.dictionary.validation);
    }

    return language;
}

async function initTh() {
    const language = languages['th'];

    language.dictionary = (
        await import('./th')
    ).default;

    if (language.dictionary.validation) {
        setYupLocale(language.dictionary.validation);
    }

    return language;
}


export function getLanguage() {
    return languages[getLanguageCode()];
}

function format(message: string, args: any) {
    if (!message) {
        return null;
    }

    try {
        return message.replace(/{(\d+)}/g, function (
            match,
            number,
        ) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match;
        });
    } catch (error) {
        console.error(message, error);
        throw error;
    }
}

export function getLanguages() {
    return Object.keys(languages).map((language) => {
        return languages[language];
    });
}

export function getLanguageCode() {
    return currentLanguageCode;
}

export function setLanguageCode(arg: any) {
    if (!languages[arg]) {
        throw new Error(`Invalid language ${arg}.`);
    }

    secureLocalStorage.setItem('languageUvoice', arg);
}

export function i18nExists(key: any) {
    if (!getLanguage()) {
        return false;
    }

    const message = _get(getLanguage().dictionary, key);
    return Boolean(message);
}

export function i18n(key: any, ...args: any) {
    if (!getLanguage()) {
        return key;
    }

    const message = _get(getLanguage().dictionary, key);

    if (!message) {
        return key;
    }

    return format(message, args);
}

// export function i18nHtml(key: any, ...args: any) {
//     return (
//         <span
//             dangerouslySetInnerHTML={{
//                 __html: i18n(key, ...args),
//             }}
//         />
//     );
// }
